import { createFileRoute } from "@tanstack/react-router";
import { VideoScanInfoPage } from "./videoskanning";

export const Route = createFileRoute("/en/video-scan")({
  head: () => ({
    meta: [
      { title: "Video scan – film your item and get a listing | Sellavo" },
      { name: "description", content: "Film your item and Sellavo turns the video into photos, title, description and price." },
      { property: "og:title", content: "Video scan – film your item and get a listing | Sellavo" },
      { property: "og:description", content: "Film your item and Sellavo turns the video into photos, title, description and price." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/video-scan" }],
  }),
  component: VideoScanInfoPage,
});
